import { Component, Input, OnInit } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { CustomerSatisfactionStatistics } from '../../../models/customerSatisfactionStatistics.model';

@UntilDestroy()
@Component({
	templateUrl: './survey-customer-satisfaction-v1.component.html',
	styleUrls: ['./survey-customer-satisfaction-v1.component.scss']
})
export class SurveyCustomerSatisfactionV1Component implements OnInit {

	@Input() statistics: CustomerSatisfactionStatistics[] = [];


	public q1Question = 'Au cours de la mission, vos remarques ont-elles été prises en compte par le Chef de Projet des Consultants A2L ?';
	public q1CheckOptions = [
		{ label: 'Jamais', value: 'a1' },
		{ label: 'Parfois', value: 'a2' },
		{ label: 'La majorité du temps', value: 'a3' },
		{ label: 'Absolument', value: 'a4' },
	];

	public q2Question = 'Avez-vous eu suffisamment de visibilité sur l\'avancée des travaux tout au long du projet ?';
	public q2CheckOptions = [
		{ label: 'Jamais', value: 'a1' },
		{ label: 'Parfois', value: 'a2' },
		{ label: 'La majorité du temps', value: 'a3' },
		{ label: 'Absolument', value: 'a4' },
	];

	public q3Question = 'Est-ce que vous pensez que toutes les ressources ont été mises à votre disposition pour que cette mission se déroule au mieux ?';
	public q3CheckOptions = [
		{ label: 'Jamais', value: 'a1' },
		{ label: 'Parfois', value: 'a2' },
		{ label: 'La majorité du temps', value: 'a3' },
		{ label: 'Absolument', value: 'a4' },
	];

	public q4Question = 'Avez-vous déjà fait appel à A2L Consultants ?';
	public q4CheckOptions = [
		{ label: 'Oui', value: 'a1' },
		{ label: 'Non', value: 'a2' },
	];

	public q5Question = 'La certification ISO 9001 a-t-elle constitué une raison dans votre choix de confier cette mission à A2L Consultants ?';
	public q5CheckOptions = [
		{ label: 'Oui', value: 'a1' },
		{ label: 'Non', value: 'a2' },
	];

	public q6Question = 'A combien estimez-vous votre satisfaction globale ?';
	public q6CheckOptions = [
		{ label: 'Pas du tout satisfait', value: 'a1' },
		{ label: 'Globalement pas satisfait', value: 'a2' },
		{ label: 'Globalement satisfait', value: 'a3' },
		{ label: 'Entièrement satisfait', value: 'a4' },
	];

	public q7Question = 'Avez-vous une remarque à faire pour compléter vos réponses aux questions précédentes ?';

	public q8Question = 'Le livrable correspond-il à vos attentes ?';
	public q8CheckOptions = [
		{ label: 'Pas du tout', value: 'a1' },
		{ label: 'Globalement non', value: 'a2' },
		{ label: 'Globalement oui', value: 'a3' },
		{ label: 'Complètement', value: 'a4' },
	];

	public q9Question = 'Vous êtes-vous senti impliqué et informé par les membres d\'A2L Consultants tout au long de ce projet ?';
	public q9CheckOptions = [
		{ label: 'Jamais', value: 'a1' },
		{ label: 'Parfois', value: 'a2' },
		{ label: 'La majorité du temps', value: 'a3' },
		{ label: 'Absolument', value: 'a4' },
	];

	public q10Question = 'Recommanderiez-vous A2L à d\'autres ?';
	public q10CheckOptions = [
		{ label: 'Oui', value: 'a1' },
		{ label: 'Non', value: 'a2' },
	];

	public q11Question = 'Seriez-vous prêt à faire appel à A2L Consultants à nouveau pour une mission similaire ?';
	public q11CheckOptions = [
		{ label: 'Oui', value: 'a1' },
		{ label: 'Non', value: 'a2' },
	];

	public q12Question = 'Avez-vous une remarque à faire pour compléter vos réponses aux questions précédentes ?';

	constructor() {
	}

	ngOnInit() {
		this.updateCustomerSatisfactionData();
	}

	private updateCustomerSatisfactionData() {
		for (const statistic of this.statistics) {
			if (!statistic.answers) {
				return;
			}
			for (const element of this.q1CheckOptions) {
				if (statistic.answers.q1 === element.value) {
					statistic.formattedAnswers.q1 = element.label;
				}
			}
			for (const element of this.q2CheckOptions) {
				if (statistic.answers.q2 === element.value) {
					statistic.formattedAnswers.q2 = element.label;
				}
			}
			for (const element of this.q3CheckOptions) {
				if (statistic.answers.q3 === element.value) {
					statistic.formattedAnswers.q3 = element.label;
				}
			}
			for (const element of this.q4CheckOptions) {
				if (statistic.answers.q4 === element.value) {
					statistic.formattedAnswers.q4 = element.label;
				}
			}
			for (const element of this.q5CheckOptions) {
				if (statistic.answers.q5 === element.value) {
					statistic.formattedAnswers.q5 = element.label;
				}
			}
			for (const element of this.q6CheckOptions) {
				if (statistic.answers.q6 === element.value) {
					statistic.formattedAnswers.q6 = element.label;
				}
			}
			statistic.formattedAnswers.q7 = statistic.answers.q7;
			for (const element of this.q8CheckOptions) {
				if (statistic.answers.q8 === element.value) {
					statistic.formattedAnswers.q8 = element.label;
				}
			}
			for (const element of this.q9CheckOptions) {
				if (statistic.answers.q9 === element.value) {
					statistic.formattedAnswers.q9 = element.label;
				}
			}
			for (const element of this.q10CheckOptions) {
				if (statistic.answers.q10 === element.value) {
					statistic.formattedAnswers.q10 = element.label;
				}
			}
			for (const element of this.q11CheckOptions) {
				if (statistic.answers.q11 === element.value) {
					statistic.formattedAnswers.q11 = element.label;
				}
			}
			statistic.formattedAnswers.q12 = statistic.answers.q12;
		}
	}
}
